/* src/routes/about/index.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	query_selector_all,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../../web_modules/svelte/internal.js";

import Btn from "../../../_components/Btn.js";
import Content from "../../../_components/Content.js";

function create_default_slot_1(ctx) {
	let t;

	return {
		c() {
			t = text("Contact me!");
		},
		l(nodes) {
			t = claim_text(nodes, "Contact me!");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (12:0) <Content>
function create_default_slot(ctx) {
	let h3;
	let t0;
	let t1;
	let p;
	let t2;
	let t3;
	let a;
	let btn;
	let current;

	btn = new Btn({
			props: {
				btn: "filled",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			h3 = element("h3");
			t0 = text("about");
			t1 = space();
			p = element("p");
			t2 = text("Website currently under construction!");
			t3 = space();
			a = element("a");
			create_component(btn.$$.fragment);
			this.h();
		},
		l(nodes) {
			h3 = claim_element(nodes, "H3", {});
			var h3_nodes = children(h3);
			t0 = claim_text(h3_nodes, "about");
			h3_nodes.forEach(detach);
			t1 = claim_space(nodes);
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t2 = claim_text(p_nodes, "Website currently under construction!");
			p_nodes.forEach(detach);
			t3 = claim_space(nodes);
			a = claim_element(nodes, "A", { href: true });
			var a_nodes = children(a);
			claim_component(btn.$$.fragment, a_nodes);
			a_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(a, "href", "/contact");
		},
		m(target, anchor) {
			insert(target, h3, anchor);
			append(h3, t0);
			insert(target, t1, anchor);
			insert(target, p, anchor);
			append(p, t2);
			insert(target, t3, anchor);
			insert(target, a, anchor);
			mount_component(btn, a, null);
			current = true;
		},
		p(ctx, dirty) {
			const btn_changes = {};

			if (dirty & /*$$scope*/ 1) {
				btn_changes.$$scope = { dirty, ctx };
			}

			btn.$set(btn_changes);
		},
		i(local) {
			if (current) return;
			transition_in(btn.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(btn.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(h3);
			if (detaching) detach(t1);
			if (detaching) detach(p);
			if (detaching) detach(t3);
			if (detaching) detach(a);
			destroy_component(btn);
		}
	};
}

function create_fragment(ctx) {
	let t;
	let content;
	let current;

	content = new Content({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			t = space();
			create_component(content.$$.fragment);
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-1nch3lh\"]", document.head);
			head_nodes.forEach(detach);
			t = claim_space(nodes);
			claim_component(content.$$.fragment, nodes);
			this.h();
		},
		h() {
			document.title = "About • clp.is";
		},
		m(target, anchor) {
			insert(target, t, anchor);
			mount_component(content, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const content_changes = {};

			if (dirty & /*$$scope*/ 1) {
				content_changes.$$scope = { dirty, ctx };
			}

			content.$set(content_changes);
		},
		i(local) {
			if (current) return;
			transition_in(content.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(content.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t);
			destroy_component(content, detaching);
		}
	};
}

let selected = "about";

class About extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default About;
//# sourceMappingURL=index.js.map
